import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-expedia-wizard-step1',
  templateUrl: './connect-expedia-wizard-step1.component.html',
  styleUrls: ['./connect-expedia-wizard-step1.component.scss'],
})
export class ConnectExpediaWizardStep1Component implements OnInit {
  @Output() next = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
